export var INVITE_AMBASSADORS_TYPES;
(function (INVITE_AMBASSADORS_TYPES) {
    INVITE_AMBASSADORS_TYPES["TAP"] = "tap";
    INVITE_AMBASSADORS_TYPES["IDP_AND_TAP"] = "idp_and_tap";
    INVITE_AMBASSADORS_TYPES["IDP"] = "idp";
})(INVITE_AMBASSADORS_TYPES || (INVITE_AMBASSADORS_TYPES = {}));
